import * as yup from "yup";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const contactSchema = yup.object().shape({
  name: yup
    .string()
    .required("Name field is required")
    .test(
      "len",
      "Name must not be less than 5 characters",
      (val) => val.length > 5,
    ),
  email: yup
    .string()
    .required("Email address field is required")
    .email("Invalid email address"),
  phone: yup
    .string()
    .required("Phone number field is required")
    .matches(phoneRegExp, "Phone number is not valid"),
  country: yup.string().required("Country field is required"),
  message: yup
    .string()
    .required("Message field is required")
    .test(
      "len",
      "Message must not be less than 10 characters",
      (val) => val.length > 10,
    ),
});
